import PropTypes from "prop-types";
import { userShape } from "../shapes";

/**
 * PropTypes for Profile view
 *
 * @property {User} [user] - User data object
 * @property {function} [onUpdate] - Profile update handler
 * @property {boolean} [loading] - Loading state
 */
export const profilePropTypes = {
  user: userShape,
  onUpdate: PropTypes.func,
  loading: PropTypes.bool,
};

/**
 * PropTypes for Security view
 *
 * @property {function} [onChangePassword] - Password change handler
 * @property {function} [onEnable2FA] - Enable 2FA handler
 * @property {boolean} [twoFactorEnabled] - 2FA enabled state
 * @property {boolean} [loading] - Loading state
 */
export const securityPropTypes = {
  onChangePassword: PropTypes.func,
  onEnable2FA: PropTypes.func,
  twoFactorEnabled: PropTypes.bool,
  loading: PropTypes.bool,
};

/**
 * PropTypes for AccountSettings view
 *
 * @property {Object} [settings] - Account settings object
 * @property {function} [onUpdate] - Settings update handler
 * @property {boolean} [loading] - Loading state
 */
export const accountSettingsPropTypes = {
  settings: PropTypes.object,
  onUpdate: PropTypes.func,
  loading: PropTypes.bool,
};
